﻿export const navigationFunctions = () => {
    const mainNavContainer: HTMLElement | null = document.querySelector(".main-site-header");

    if (!mainNavContainer) {
        return;
    }

    handleBurgerMenu(mainNavContainer);
    handleSearchOverlay(mainNavContainer);
};

const toggleMenu = (nav: HTMLElement) => {
    const burgerMenu = nav.querySelector(".main-site-header__burger-menu");
    const navMenu = nav.querySelector(".main-site-header__mobile-nav");
    if (!burgerMenu || !navMenu) return;
    
    navMenu.classList.toggle("main-site-header__mobile-nav--active");
    burgerMenu.classList.toggle("main-site-header__burger-menu--active");
    burgerMenu.setAttribute("aria-expanded", burgerMenu.classList.contains("main-site-header__burger-menu--active") ? "true" : "false");
    burgerMenu.setAttribute("aria-label", burgerMenu.classList.contains("main-site-header__burger-menu--active") ? "Close menu" : "Main site menu");
};

export const handleBurgerMenu = (nav: HTMLElement) => {
    const burgerMenu = nav.querySelector(".main-site-header__burger-menu");
    if (!burgerMenu) return;
    
    burgerMenu.addEventListener("click", () => toggleMenu(nav));
};

export const handleSearchOverlay = (nav: HTMLElement) => {
    const searchButton = nav.querySelector<HTMLButtonElement>(".main-site-header__search-button");
    const searchOverlay = document.getElementById("search-overlay");
    const closeButton = searchOverlay?.querySelector<HTMLButtonElement>(".close-button");
    const searchInput = searchOverlay?.querySelector<HTMLInputElement>(".search-overlay-nav .jobsearchinput .attrax-form-item__input");

    if (!searchButton || !searchOverlay || window.innerWidth >= 768) return;

    const showOverlay = () => {
        searchOverlay.classList.add("search-overlay-nav--active");
        searchOverlay.setAttribute("aria-hidden", "false");
        searchButton.setAttribute("aria-expanded", "true");

        setTimeout(() => searchInput?.focus(), 300);
    };

    const hideOverlay = () => {
        searchOverlay.classList.remove("search-overlay-nav--active");
        searchOverlay.setAttribute("aria-hidden", "true");
        searchButton.setAttribute("aria-expanded", "false");

        const burgerMenu = nav.querySelector(".main-site-header__burger-menu");
        if (burgerMenu?.classList.contains("main-site-header__burger-menu--active")) {
            toggleMenu(nav);
        }
    };

    searchButton.addEventListener("click", showOverlay);
    closeButton?.addEventListener("click", hideOverlay);
};
